import { __assign } from '../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

var CalendarIcon = forwardRef(function (props, ref) {
    return (React.createElement(SvgIcon, __assign({}, props, { ref: ref }),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14.444", height: "15", viewBox: "0 0 14.444 15" },
            React.createElement("path", { "data-name": "Calendar-icon", d: "M7.977 15h10.467a1.99 1.99 0 0 0 1.989-1.989V3.1a1.99 1.99 0 0 0-1.989-1.989h-.789V.556a.556.556 0 0 0-1.111 0v.556H9.877V.556a.556.556 0 0 0-1.111 0v.556h-.789A1.99 1.99 0 0 0 5.988 3.1v9.911A1.99 1.99 0 0 0 7.977 15zM7.1 3.1a.88.88 0 0 1 .878-.878h.789v.556a.556.556 0 1 0 1.111 0v-.556h6.667v.556a.556.556 0 0 0 1.111 0v-.556h.789a.88.88 0 0 1 .878.878v1.622H7.1zm0 2.733h12.221v7.178a.88.88 0 0 1-.878.878H7.977a.88.88 0 0 1-.878-.878z", transform: "translate(-5.988)", fill: "currentColor" }))));
});

export { CalendarIcon };
//# sourceMappingURL=CalendarIcon.js.map
